import React from 'react';
import './MacWindow.css';

const MacWindow: React.FC = () => {
  return (
    <div className="mac-window">
      <div className="window-buttons">
        <div className="window-button close-button"></div>
        <div className="window-button minimize-button"></div>
        <div className="window-button maximize-button"></div>
      </div>
      <div className="content">
        <img src="/assets/logo.png" alt="Pigeon Labs Logo" className="logo" />
        <h1 className="title">Pigeon Labs</h1>
        <h2 className="tagline">Building clever digital tools for the modern world.</h2>
        
        <p className="about">Pigeon Labs LLC is a software company registered in Tbilisi, Georgia. We focus on building consumer mobile applications that combine behavioral science, automation, and elegant design.</p>
        
        <p className="mission">Our mission is to create tools that help people live better, healthier, and more productive lives.</p>
        
        <div className="contact-section">
          <h2 className="contact-title">Contact Us</h2>
          <p className="contact-text">We'd love to hear from you. For inquiries, partnerships, or just to say hello, reach us at:</p>
          <p className="contact-email">
            <a href="mailto:hello@pigeonlabs.xyz">📩 hello@pigeonlabs.xyz</a>
          </p>
        </div>
      </div>
      <div className="status-bar">
        <p>Built with ❤️ in Tbilisi, Georgia 🇬🇪</p>
      </div>
    </div>
  );
};

export default MacWindow; 